import { useIntersectionObserver } from '@/hooks/use-intersection-observer'
import { cn } from '@/lib/utils'
import { X } from 'lucide-react'

export const AgitationSection = () => {
  const { elementRef, isVisible } = useIntersectionObserver({
    threshold: 0.1,
  })

  const pains = [
    'Infoprodutos falidos.',
    'Tráfego que queima dinheiro.',
    'Promessas vazias.',
  ]

  return (
    <section
      ref={elementRef}
      className="bg-white py-16 md:py-24 lg:py-32 overflow-hidden"
    >
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-4xl mx-auto flex flex-col items-center text-center">
          {/* Headline */}
          <h2
            className={cn(
              'font-heading font-black text-2xl sm:text-3xl md:text-5xl lg:text-6xl leading-[1.1] text-black uppercase mb-10 md:mb-16 transition-all duration-700 ease-out transform text-balance tracking-tight',
              isVisible
                ? 'opacity-100 translate-y-0'
                : 'opacity-0 translate-y-12',
            )}
          >
            Cansado de ser mais um perdedor no digital?
          </h2>

          {/* Pains List - Staggered Reveal */}
          <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-4 sm:gap-6 md:gap-12 mb-10 md:mb-16 w-full">
            {pains.map((pain, idx) => (
              <div
                key={idx}
                className={cn(
                  'flex items-center justify-start sm:justify-center gap-3 sm:gap-4 font-bold text-base sm:text-lg md:text-xl text-black transition-all duration-700 ease-out transform bg-gray-50 sm:bg-transparent p-3 sm:p-0 rounded-lg sm:rounded-none border sm:border-none border-gray-100',
                  isVisible
                    ? 'opacity-100 translate-y-0'
                    : 'opacity-0 translate-y-8',
                )}
                style={{ transitionDelay: `${(idx + 1) * 150}ms` }}
              >
                <div className="flex items-center justify-center w-8 h-8 md:w-10 md:h-10 rounded-full bg-red-100 shrink-0">
                  <X className="w-5 h-5 md:w-6 md:h-6 text-red-600 stroke-[3]" />
                </div>
                <span className="text-left">{pain}</span>
              </div>
            ))}
          </div>

          {/* Body Text */}
          <div className="flex flex-col gap-4 md:gap-6 text-base sm:text-lg md:text-xl font-sans font-medium text-gray-800 text-center max-w-3xl leading-relaxed px-2">
            <p
              className={cn(
                'transition-all duration-700 ease-out transform',
                isVisible
                  ? 'opacity-100 translate-y-0'
                  : 'opacity-0 translate-y-8',
              )}
              style={{ transitionDelay: '600ms' }}
            >
              Você está exausto de tentar e não ver resultado.
            </p>
            <p
              className={cn(
                'transition-all duration-700 ease-out transform text-balance',
                isVisible
                  ? 'opacity-100 translate-y-0'
                  : 'opacity-0 translate-y-8',
              )}
              style={{ transitionDelay: '800ms' }}
            >
              Enquanto você luta, uma elite fatura{' '}
              <span className="font-black">ALTO</span> em dólar com agências de
              OnlyFans.
            </p>
            <p
              className={cn(
                'transition-all duration-700 ease-out transform',
                isVisible
                  ? 'opacity-100 translate-y-0'
                  : 'opacity-0 translate-y-8',
              )}
              style={{ transitionDelay: '1000ms' }}
            >
              Essa é a <span className="font-black text-red-600">ÚNICA</span>{' '}
              onda que sobrou. E ela está fechando.
            </p>
          </div>

          {/* Secondary CTA */}
          <div
            className={cn(
              'mt-10 md:mt-16 transition-all duration-700 ease-out transform w-full',
              isVisible
                ? 'opacity-100 translate-y-0'
                : 'opacity-0 translate-y-8',
            )}
            style={{ transitionDelay: '1200ms' }}
          >
            <a
              href="https://wa.me/558393917008?text=Fala%20Lucas%2C%20gostaria%20de%20saber%20mais%20sobre%20a%20mentoria%20OFM%20ELITE%21"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary text-lg sm:text-xl md:text-2xl font-black uppercase tracking-wide cursor-pointer hover:scale-105 transition-transform animate-pulse border-b-2 border-primary pb-1 active:scale-95 touch-manipulation inline-block"
            >
              Você vai entrar ou vai assistir de fora?
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}
